interface ArrowDownProps {
  className?: string
  variant?: 'black' | 'white' | 'primary' | 'primary-light'
}

export default function ArrowDown({ className = '', variant = 'white' }: ArrowDownProps) {
  return (
    <svg
      className={`h-4 w-4 ${className}`}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="10"
      viewBox="0 0 16 10"
      fill="none"
    >
      <g clipPath="url(#clip0_5038_136)">
        <path
          d="M10.4947 4.79492C12.7747 2.15835 15.0547 1.98006 15.0547 1.98006L12.793 0.873779C12.793 0.873779 10.6513 2.10464 9.09702 4.65321C8.30159 5.99035 7.85245 6.95149 7.62845 7.59264C7.4033 6.95264 6.95416 5.98921 6.14273 4.65321C4.5873 2.10464 2.44444 0.873779 2.44444 0.873779L0.19873 1.97892C0.19873 1.97892 2.47873 2.15721 4.75873 4.79378C6.74616 7.11035 7.36787 8.62578 7.36787 8.62578H7.90387C7.88673 8.62578 8.52559 7.09321 10.4947 4.79378V4.79492Z"
          fill={
            variant === 'white'
              ? 'white'
              : variant === 'primary'
                ? '#896145'
                : variant === 'primary-light'
                  ? '#896145'
                  : 'black'
          }
        />
      </g>
      <defs>
        <clipPath id="clip0_5038_136">
          <rect width="16" height="9.14286" fill="white" transform="translate(0 0.428467)" />
        </clipPath>
      </defs>
    </svg>
  )
}
